import { useTranslation } from 'react-i18next';
import Link from '../../../../../shared/Link/Link';
import { generalLinks } from '../constants';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';

import './PalmFooterGeneralLinks.scss';

export function PalmFooterGeneralLinks() {
  const { sitePath } = useRootSelector(selectPageConfig);
  const { t } = useTranslation();
  const getTitle = (title: string) => t(title);

  return (
    <div className="c-palm-magazine-footer-general-links-wrapper">
      <div className="container">
        <div className="c-palm-magazine-footer-general-links">
          <ul>
            {generalLinks.map((item, i) => (
              <li
                key={i + item.title}
                className="c-palm-magazine-footer-general-links__item"
              >
                <Link
                  to={item.href}
                  event={sitePath}
                  className="c-palm-magazine-footer-general-links__link"
                  target={item.target}
                >
                  {getTitle(item.title)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PalmFooterGeneralLinks;
